var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,0a9,9,0,1,0,9,9A9.026,9.026,0,0,0,9,0ZM9,16.125A7.17,7.17,0,0,1,1.875,9,7.17,7.17,0,0,1,9,1.875,7.17,7.17,0,0,1,16.125,9,7.17,7.17,0,0,1,9,16.125Z",
    transform: "translate(3 3)",
    fill: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.675,4.35H6.3V.975a.975.975,0,1,0-1.95,0V4.35H.975a.975.975,0,1,0,0,1.95H4.35V9.675a.975.975,0,1,0,1.95,0V6.3H9.675a.975.975,0,1,0,0-1.95Z",
    transform: "translate(6.675 6.675)",
    fill: "#fcfcfc"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/Add.0252c7d53ccdb84991cde9500f0eb601.svg";
export { ForwardRef as ReactComponent };